import React from "react";
import { ColumnConfig, TableSearchConfig } from "../table/dto";

export interface ITransferProps {
  flag?: number; // 强制刷新标志符
  style?: React.CSSProperties; // 内部样式
  className?: string; // 包装器类名
  /**
   * 接口参数
   */
  extraParam?: ExtraParamsProps;
  /**
   * 以下列的方法执行后触发已关联table刷新
   */
  refreshRely?: string[];
  /**
   * 已关联操作区配置
   */
  operationBarConfig?: {
    title: string;
    disabled?: boolean;
    onClick?: (parms?: Record<string, any>) => Promise<unknown>;
  };
  /**
   * 查询相关配置
   */
  searchConfig?: SearchConfig;
  /**
   * api文件名
   */
  relationName: string;
  /**
   * 接口参数
   */
  record?: Record<string, any>;
  /**
   * 公共列配置
   */
  columns: ColumnConfig[];
  /**
   * 额外的列
   * 配置字符串时即意味使用组件内部预设的列
   */
  extraColumns?: ExtraColumnsConfig;
  /**
   * 模态框是否显示
   */
  visible: boolean;
  /**
   * 提示信息配置
   */
  tipConfig?: TipConfig;
  /**
   * 表格数据处理配置
   */
  dataTransform?: DataTransformConfig;
  /**
   * 转换绑定接口参数数据结构
   */
  handleBindApiParam: ApiParamsTransferConfig;
  /**
   * 转换解绑接口参数数据结构
   */
  handleUnbindApiParam: ApiParamsTransferConfig;
  /**
   * 转换是否必填接口参数数据结构
   */
  handleRequiredApiParam?: ApiParamsTransferConfig;
  /**
   * 关联数据发生变化
   */
  onChange?: (type: "plus" | "minus") => void;
}

interface ExtraParamsProps {
  key?: string[];
  value?: string[];
  [props: string]: any;
}
interface SearchConfig {
  disrelated?: TableSearchConfig;
  related?: TableSearchConfig;
}

interface ExtraColumnsConfig {
  disrelated?: Array<ColumnConfig | string>;
  related?: Array<ColumnConfig | string>;
}

interface TipConfig {
  bind: string;
  unbind: string;
  required?: string;
  operation?: string;
}

interface DataTransformConfig {
  disrelated?: (list: Record<string, any>) => Record<string, any>[];
  related?: (list: Record<string, any>) => Record<string, any>[];
}

type ApiParamsTransferConfig = (
  record: Record<string, any>
) => Record<string, any>;

// eslint-disable-next-line no-shadow
export enum TransferName {
  Related = "related",
  Disrelated = "disrelated",
}
